(() => {
  'use strict';
  const copyNode = document.getElementById('U4MerchCopy');
  if (!copyNode || customElements.get('u4wd-recommendations')) return;
  const copy = JSON.parse(copyNode.textContent);
  let adding = false;
  const text = (key, values = {}) => Object.entries(values).reduce((value, [name, replacement]) => value.replaceAll(`[${name}]`, String(replacement)), copy[key] || '');
  const money = (cents, currency) => currency === 'ZAR'
    ? `R ${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100)}`
    : new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, currencyDisplay: 'narrowSymbol' }).format(cents / 100);
  const readJSON = async (url) => {
    try {
      const response = await fetch(url, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error(copy.check_error);
      return await response.json();
    } catch (error) { throw new Error(copy.check_error); }
  };
  const jsonURL = (path) => path.endsWith('.js') ? path : `${path}.js`;
  const cartJSON = () => readJSON(jsonURL(routes.cart_url));
  const covered = (card, cart) => {
    const ids = (card.dataset.suppressionIds || card.dataset.productId).split(',');
    return cart.items.some((item) => ids.includes(String(item.product_id)));
  };
  const syncRegion = (region) => {
    const hasChoice = Array.from(region.querySelectorAll('[data-u4-merch-card]')).some((card) => !card.hidden);
    region.hidden = !hasChoice;
    const section = region.closest('[data-u4-merch-section]');
    if (section) {
      section.hidden = !hasChoice;
      document.querySelectorAll('[data-u4-merch-jump]').forEach((link) => { link.hidden = !hasChoice; });
    }
  };
  const syncChoices = (cart) => {
    document.querySelectorAll('u4wd-recommendations').forEach((region) => {
      region.querySelectorAll('[data-u4-merch-card]').forEach((card) => { card.hidden = covered(card, cart) || card.dataset.unavailable === 'true'; });
      syncRegion(region);
    });
  };
  const updateQuantity = (form) => {
    const quantity = Number(form.elements.namedItem('quantity')?.value);
    const total = Number(form.dataset.unitPrice) * quantity;
    const isCover = form.dataset.purpose.startsWith('cover');
    const label = isCover ? (quantity === 2 ? 'add_two_covers' : 'add_one_cover') : 'add_one_light';
    form.querySelector('[data-u4-merch-button]').textContent = `${copy[label]} · ${money(total, form.dataset.currency)}`;
    const saving = form.querySelector('[data-u4-merch-saving]');
    const active = (form.dataset.campaignActive || '').trim() === 'true' && Date.now() <= Date.parse(form.dataset.campaignEnds);
    saving.hidden = !active;
    if (active) saving.textContent = text('after_offer', { amount: money(total - Math.round(total * 0.1), form.dataset.currency) });
  };
  const descriptors = () => {
    const fullCart = document.querySelector('cart-items');
    if (fullCart) return fullCart.getSectionsToRender();
    const drawer = document.querySelector('cart-drawer');
    return drawer ? drawer.getSectionsToRender().map((entry) => ({ ...entry, section: entry.id })) : [];
  };
  const readSections = async (entries) => {
    const ids = [...new Set(entries.map((entry) => entry.section || entry.id))].slice(0, 5);
    if (!ids.length) return {};
    const url = new URL(routes.cart_url, location.origin);
    url.searchParams.set('sections', ids.join(','));
    return readJSON(url.pathname + url.search);
  };
  const applySections = (sections, entries) => {
    for (const entry of entries) {
      const html = sections[entry.section || entry.id];
      if (!html) throw new Error(copy.refresh_error);
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const source = parsed.querySelector(entry.selector || '.shopify-section');
      const root = document.getElementById(entry.id);
      const target = entry.selector ? root?.querySelector(entry.selector) || root : root;
      if (target && source) target.innerHTML = source.innerHTML;
    }
  };
  const announce = (message, onCart) => {
    const notice = document.getElementById(onCart ? 'U4CartMerchNotice' : 'U4DrawerMerchNotice');
    if (notice) { notice.textContent = message; notice.hidden = false; }
  };
  const setBusy = (busy) => {
    document.querySelectorAll('[data-u4-merch-add]').forEach((button) => { button.disabled = busy || button.closest('form').dataset.unavailable === 'true'; });
    document.querySelectorAll('[data-u4-merch-form] select').forEach((select) => { select.disabled = busy || select.closest('form').dataset.unavailable === 'true'; });
  };
  class U4wdRecommendations extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', (event) => {
        if (!event.target.closest('[data-u4-merch-form]')) return;
        event.stopPropagation();
        updateQuantity(event.target.closest('form'));
      });
      this.addEventListener('submit', (event) => {
        const form = event.target.closest('[data-u4-merch-form]');
        if (!form) return;
        event.preventDefault();
        event.stopPropagation();
        if (!adding) this.addChoice(form);
      });
    }
    connectedCallback() {
      this.querySelectorAll('[data-u4-merch-form]').forEach(updateQuantity);
      syncRegion(this);
      if (adding) this.querySelectorAll('[data-u4-merch-add], select').forEach((control) => { control.disabled = true; });
    }
    async addChoice(form) {
      adding = true;
      setBusy(true);
      form.setAttribute('aria-busy', 'true');
      const status = form.querySelector('[data-u4-merch-status]');
      status.textContent = copy.checking;
      const id = Number(form.dataset.variantId);
      const quantity = Number(form.elements.namedItem('quantity')?.value);
      const onCart = Boolean(document.querySelector('cart-items'));
      const card = form.closest('[data-u4-merch-card]');
      let before;
      let attempted = false;
      let posted;
      let postError = false;
      let refreshedDrawer;
      let drawerWasOpen = false;
      try {
        if (!Number.isInteger(quantity) || quantity < 1 || quantity > 2 || (quantity === 2 && !form.dataset.purpose.startsWith('cover'))) throw new Error(copy.quantity_error);
        const root = window.Shopify?.routes?.root || '/';
        const [product, currentCart] = await Promise.all([readJSON(`${root}products/${encodeURIComponent(form.dataset.productHandle)}.js`), cartJSON()]);
        before = currentCart;
        if (covered(card, before)) { syncChoices(before); throw new Error(copy.already_present); }
        const variant = product.variants.find((entry) => Number(entry.id) === id && entry.sku === form.dataset.expectedSku);
        if (!variant || !variant.available) {
          form.dataset.unavailable = 'true';
          card.querySelector('.u4-merch-card__availability').textContent = copy.unavailable;
          throw new Error(copy.unavailable);
        }
        if (Number(variant.price) !== Number(form.dataset.unitPrice)) {
          form.dataset.unitPrice = String(variant.price);
          card.querySelector('.u4-merch-card__price strong').textContent = money(variant.price, before.currency);
          form.querySelectorAll('select[name="quantity"] option').forEach((option) => { option.textContent = `${Number(option.value) === 2 ? copy.two_covers : copy.one_cover} · ${money(variant.price * Number(option.value), before.currency)}`; });
          updateQuantity(form);
          throw new Error(copy.price_changed);
        }
        const entries = descriptors();
        const sectionIds = [...new Set(entries.map((entry) => entry.section || entry.id))].slice(0, 5);
        attempted = true;
        try {
          const response = await fetch(jsonURL(routes.cart_add_url), {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id, quantity }], sections: sectionIds, sections_url: location.pathname }),
          });
          posted = await response.json();
          postError = !response.ok;
        } catch (error) { postError = true; }
        // A stock or rendering error can still change a Shopify cart. Always reconcile; never repeat the POST.
        const cart = await cartJSON();
        const beforeCount = before.items.filter((item) => Number(item.variant_id) === id).reduce((sum, item) => sum + item.quantity, 0);
        const afterCount = cart.items.filter((item) => Number(item.variant_id) === id).reduce((sum, item) => sum + item.quantity, 0);
        const added = Math.max(0, afterCount - beforeCount);
        let sections = posted?.sections;
        if (!sections || entries.some((entry) => !sections[entry.section || entry.id])) sections = await readSections(entries);
        const message = added === quantity ? text('added', { count: added }) : added > 0 ? text('partial', { count: added, requested: quantity }) : (postError ? copy.not_confirmed : copy.not_added);
        if (!onCart) {
          const drawer = document.querySelector('cart-drawer');
          const returnTarget = document.querySelector('product-info button[name="add"]') || document.querySelector('.u4-cart-link');
          if (drawer) {
            refreshedDrawer = drawer;
            drawerWasOpen = drawer.classList.contains('active');
            drawer.setActiveElement(returnTarget);
            drawer.renderContents({ id, sections });
          }
          else applySections(sections, entries);
        } else applySections(sections, entries);
        syncChoices(cart);
        announce(message, onCart);
        if (refreshedDrawer && drawerWasOpen) {
          const notice = document.getElementById('U4DrawerMerchNotice');
          const focusTarget = notice || refreshedDrawer.querySelector('.drawer__close');
          if (notice) notice.tabIndex = -1;
          trapFocus(document.getElementById('CartDrawer'), focusTarget);
        }
        await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'u4wd-recommendations', sectionsApplied: true, cartData: cart, productVariantId: id });
        if (onCart) {
          const notice = document.getElementById('U4CartMerchNotice');
          if (notice) { notice.tabIndex = -1; notice.focus({ preventScroll: true }); }
        }
      } catch (error) {
        const message = attempted ? copy.not_confirmed : (error.message || copy.check_error);
        if (status.isConnected) status.textContent = message;
        announce(message, onCart);
      } finally {
        adding = false;
        setBusy(false);
        form.removeAttribute('aria-busy');
        if (status.isConnected && status.textContent === copy.checking) status.textContent = '';
      }
    }
  }
  customElements.define('u4wd-recommendations', U4wdRecommendations);
  subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
    if (event.source === 'u4wd-recommendations') return;
    try { syncChoices(Array.isArray(event.cartData?.items) ? event.cartData : await cartJSON()); } catch (error) { /* Existing native cart errors remain authoritative. */ }
  });
})();
